var exports = {
  "kL": "x93eb46d8--38c033--container",
  "Pl": "x93eb46d8--38c033--prefix",
  "wG": "x93eb46d8--38c033--postfix",
};

module.exports = exports;
